import React from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import Breadcrumbs from '../../components/Breadcrumb';
import ExpandableCard from '../../components/ExpandableCard';
import MarkTopicAsReadButton from '../../components/MarkTopicAsReadButton';
import { useOverviewContext } from '../../context/OverviewContext';
import { FooterMobile } from '../../Layout/FooterMobile';
import { useChecklist } from '../../context/ChecklistContext';
import { getCurrentChecklistId } from '../../utils/checklistUtils';

const SampleLessons: React.FC = () => {
    const { students } = useOverviewContext(); 
    console.log(students);
    const breadcrumbItems = [
        { label: "Home", path: "/" },
        { label: "School Prep Checklist", path: "/school-prep-checklist" },
        { label: "Online School", path: "/k12-checklist-category/online-school" },
        { label: "Sample Lessons" },
    ];
    // Get checklist data & currentChecklistId from ChecklistContext
    const { checklistData } = useChecklist();
    const currentChecklistId = getCurrentChecklistId(checklistData, "SAMPLE_LESSONS");
      
    const sectionStyle: React.CSSProperties = {
        minHeight: 0,
        padding: 0
    };

    // Function to get lesson details based grade Logic
    const getLessonDetails = (grade: number) => {
        if (grade >= 0 && grade <= 5) {
            return {
                schoolName: "Elementary School",
                gradeRange : "K-5",
                identifier: "elementary",
                description: "Get excited for 5th Grade Earth, Life, and Physical Science! Try the interactive lessons here.",
                iframeSrc: "https://learnx-svc.k12.com/learnx-svc/getIndex/token/calmsToken/conceptId/638484/conceptType/ACTIVITY?documentId=5a03377b02d1d0a68784c62d#/activity/638484/page/1"
            };
        } else if (grade >= 6 && grade <= 8) {
            return {
                schoolName: "Middle School",
                gradeRange : "6-8",
                identifier: "middle",
                description: "Delve into past times and civilizations with these middle school World History lessons.",
                iframeSrc: "https://learnx-svc.k12.com/learnx-svc/getIndex/token/calmsToken/conceptId/504718/conceptType/ACTIVITY?documentId=5a033a7602d1d0a68784dafa#/activity/504718/page/1"
            };
        } else if (grade >= 9 && grade <= 12) {
            return {
                schoolName: "High School",
                gradeRange : "9-12",
                identifier: "high",
                description: "Mix it up in our interactive high school chemistry course sample!",
                iframeSrc: "https://learnx-svc.k12.com/learnx-svc/getIndex/token/calmsToken/conceptId/504732/conceptType/ACTIVITY?documentId=5a033a7602d1d0a68784dafa#/activity/504732/page/1"
            };
        }
        return null;
    };

    
    // Group students by gradeRange to display accordian
    const gradeGroups = students.reduce((acc, student) => {
        const studentGradeVal = student.grade.gradeId;
        const lesson = getLessonDetails(studentGradeVal);
        if (!lesson) return acc;

        const { gradeRange } = lesson;
        if (!acc[gradeRange]) {
            acc[gradeRange] = { ...lesson, students: [] };
        }
        acc[gradeRange].students.push(student);
        return acc;
    }, {} as Record<string, { schoolName: string; gradeRange: string; identifier: string; description: string; iframeSrc: string; students: typeof students }>);

    return (
        <div className="home-layout">
            <div className="sidebar-wrapper">
                <Sidebar />
            </div>
            <div className="body-wrapper-content">
                <div className="row">
                    <div className="col-12">
                        <Header />
                        <div className="main-content">
                            <div className="row">
                                <div className="col-12">
                                    <Breadcrumbs items={breadcrumbItems} />
                                </div>
                            </div>
                            <div className="wp-block-k12-section container-fluid bg-color-transparent">
                                <div className="row">
                                    <div className="col-12 g-0">
                                        <div className="wp-block-k12-hero" style={sectionStyle}>
                                            <div className="row no-wrap">
                                                <div className="col-sm-12 col-md-6 col-xl-6 col-xxl-8 align-self-center">
                                                    <h1 className="">Sample Lessons</h1>
                                                    <p className="heading-4">
                                                        Ready to dive into some course content? Try out a sample lesson!&nbsp;
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Sample Lesson Sections */}
                            <div className="wp-block-columns is-layout-flex" style={{ alignItems: "normal" }}>
                                <div className="wp-block-column is-layout-flow" style={{ flexBasis: "66.66%" }}>
                                    {Object.values(gradeGroups).map((lesson, index) => (
                                        <ExpandableCard
                                            key={index}
                                            schoolName={lesson.schoolName}
                                            title={`Sample Lesson for ${lesson.students.map(s => s.firstName).join(', ')}`} 
                                            description={lesson.description}
                                            identifier={lesson.identifier}
                                            content={
                                                <iframe
                                                    src={lesson.iframeSrc}
                                                    width="100%"
                                                    height="575"
                                                />
                                            }
                                        />
                                    ))}
                                    

                                    {/* {students.map((student, index) => {
                                        const lesson = getLessonDetails(Number(student.grade.value)); 
                                        if (!lesson) return null; 

                                        return (
                                            <ExpandableCard
                                                key={index}
                                                schoolName={lesson.schoolName}
                                                title={`Sample Lesson for ${student.firstName}`}
                                                description={lesson.description}
                                                identifier={lesson.identifier}
                                                content={
                                                    <iframe
                                                        src={lesson.iframeSrc}
                                                        width="100%"
                                                        height="575"
                                                    />
                                                }
                                            />
                                        );
                                    })} */}

                                </div>
                                <div className="wp-block-column is-layout-flow" style={{ flexBasis: "33.33%" }}></div>
                            </div>

                            {/* Topic Read Component */}
                            {currentChecklistId && <MarkTopicAsReadButton checklistId={currentChecklistId} /> } 
                        </div>
                    </div>
                </div>
            </div>
            <FooterMobile />
        </div>
    );
};

export default SampleLessons;
